import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShoppingCart, CalendarDays, ChefHat, Refrigerator, Coffee, Calculator } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    icon: <ShoppingCart className="w-8 h-8 text-gold-400" data-id="element-282" />,
    title: '📘 Tomo 1 — La Biblia del Stockeo Inteligente',
    desc: 'Sistema ICR, los 12 ingredientes base y cómo armar el primer stockeo sin desperdiciar un peso.'
  }, {
    icon: <CalendarDays className="w-8 h-8 text-gold-400" data-id="element-283" />,
    title: '📗 Tomo 2 — Menús de Supervivencia: Semanas 1 a 4',
    desc: '28 días de menú planificado. Desayuno, almuerzo, merienda y cena resueltos.'
  }, {
    icon: <ChefHat className="w-8 h-8 text-gold-400" data-id="element-284" />,
    title: '📙 Tomo 3 — Recetario "Hacer Magia"',
    desc: '30 recetas rendidoras con técnicas reales. Desde bolognesa con lentejas hasta pan casero 5 veces más barato.'
  }, {
    icon: <Refrigerator className="w-8 h-8 text-gold-400" data-id="element-285" />,
    title: '📕 Tomo 4 — El Arte de las Sobras',
    desc: 'Cero desperdicio. Cómo transformar cualquier sobra en una comida nueva. El freezer como banco de comida.'
  }, {
    icon: <Coffee className="w-8 h-8 text-gold-400" data-id="element-286" />,
    title: '📓 Tomo 5 — Viandas y Desayunos de Bajo Costo',
    desc: 'El gasto hormiga que más destruye el presupuesto. Rutina dominical y 20 viandas económicas.'
  }, {
    icon: <Calculator className="w-8 h-8 text-gold-400" data-id="element-287" />,
    title: '📔 Tomo 6 — Precios Objetivo y Sustitutos',
    desc: '50 sustitutos, tabla maestra de precios e índice anti-inflación personal.'
  }];
  const includes = ['Menú semanal listo', 'Lista de compras vinculada', 'Recetas con técnica real', 'Planillas imprimibles', 'Sistema de sobras', '100% pensado para Argentina'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-288">
      <div className="text-center mb-16" data-id="element-289">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-290">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-291">
            🏆 MEGAPACK MENÚ SEMANAL ANTI-CRISIS™
          </h2>
          <p className="text-xl md:text-2xl text-gold-400 font-medium mb-6" data-id="element-292">
            6 Tomos + 6 Bonos — El sistema completo
          </p>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto" data-id="element-293">
            Más de 300 páginas. Todo resuelto.
          </p>
        </motion.div>
      </div>

      <div className="mb-12 text-center" data-id="element-294">
        <h3 className="text-2xl font-bold text-white mb-8 border-b border-navy-700 pb-4 inline-block" data-id="element-295">
          📚 LOS 6 TOMOS
        </h3>
      </div>

      <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-16" data-id="element-296">
        {tomos.map((tomo, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/60 border border-navy-700 p-8 rounded-2xl hover:border-gold-500/50 transition-colors group" data-id="element-297">
            <div className="mb-4 p-3 bg-navy-900 rounded-xl inline-block group-hover:scale-110 transition-transform" data-id="element-298">
              {tomo.icon}
            </div>
            <h4 className="text-xl font-bold text-white mb-3" data-id="element-299">{tomo.title}</h4>
            <p className="text-blue-100/80 leading-relaxed" data-id="element-300">{tomo.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-br from-navy-800 to-navy-900 border border-gold-500/30 rounded-3xl p-8 md:p-10 max-w-4xl mx-auto" data-id="element-301">
        <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-302">
          Cada tomo incluye:
        </h4>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-303">
          {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-304">
              <CheckCircle2 className="w-6 h-6 text-green-400 shrink-0" data-id="element-305" />
              <span className="text-blue-50" data-id="element-306">{item}</span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}